import { useTranslation } from 'react-i18next';

import InfoTip from '@/components/atoms/InfoTip';
import ContentBlock from '@/components/molecules/ContentBlock';

import { PenPlot } from '../PenPlot/PenPlot';

import styles from './LivePosition.module.scss';

interface LivePositionProps {
    distance: number | null;
    depth: number | null;
    targetDistance: number | null;
    targetDepth: number | null;
    previewDistance: number | null;
    previewDepth: number | null;
    moving: boolean;
    distanceMax: number;
    depthMax: number;
}

export function LivePosition(props: LivePositionProps) {
    const {
        distance,
        depth,
        targetDistance,
        targetDepth,
        previewDistance,
        previewDepth,
        moving,
        distanceMax,
        depthMax,
    } = props;
    const { t } = useTranslation();

    return (
        <ContentBlock size="compact" shrink>
            <div className={styles.plotFrame}>
                <div className={styles.info}>
                    <InfoTip
                        label={t('winchControl.card.currentHelp')}
                        content={t('winchControl.tooltip.livePosition')}
                    />
                </div>
                <PenPlot
                    distance={distance}
                    depth={depth}
                    targetDistance={targetDistance}
                    targetDepth={targetDepth}
                    previewDistance={previewDistance}
                    previewDepth={previewDepth}
                    moving={moving}
                    distanceMax={distanceMax}
                    depthMax={depthMax}
                />
            </div>
        </ContentBlock>
    );
}
